import React from 'react'

import { GatsbyImage } from 'gatsby-plugin-image'
import { useStaticQuery, graphql } from 'gatsby'
import { Section, Container, Title, Text, ImageContainer } from './styles'

import Analytics from '../../utils/Analytics'

const Confessions = () => {
  const { cta } = useStaticQuery(graphql`
    query ConfessionsQuery {
      cta: file(relativePath: { eq: "bts/join-the-convo-cta.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
    }
  `)
  return (
    <Section>
      <Container>
        <Title>Parenting is Hard</Title>
        <Text>
          Check out our digital safe-space, where you can speak your truths and lighten the load,
          just a little.
        </Text>
        <a
          href="https://skylightconfessions.com?utm_source=homepage&utm_medium=banner&utm_campaign=confessions_bts"
          target="_blank"
          title="Join the Conversation"
          rel="noopener noreferrer"
          onClick={() => Analytics.track('Clicked Join the Conversation CTA')}
        >
          <ImageContainer>
            <GatsbyImage image={cta.childImageSharp.gatsbyImageData} alt="Join the conversation" />
          </ImageContainer>
        </a>
      </Container>
    </Section>
  )
}

export default Confessions
